import { Grid } from "@mui/material";
import ContentAccordion from "./ContentAccordion";

const ContentContainer = ({expanded, colorGradients, contents, isMobile, handleAccordionChange, isBlog, fn}) => {
    
    return (
        <>
            {expanded.length && colorGradients.length >= contents.length && (
                <>
                    {contents.map((i, j) => (
                        <Grid item xs={12} key={j}>
                            <ContentAccordion 
                                title={i.title} 
                                contentPath={`/${fn}/${i.fileName}`}
                                citationsPath={`/${fn}/${i.citations}`}
                                promptsPath={`/${fn}/${i.prompts}`}
                                gradientStyle={colorGradients[j]}
                                id={i.id}
                                isExpandedFromParent={expanded[j]}
                                isMobile={isMobile}
                                onChange={() => handleAccordionChange(j)}
                                latest={j === contents.length-1}
                                isBlog={isBlog}
                            />
                        </Grid>
                    ))}
                </>
            )}
        </>
    );
};

export default ContentContainer;